import React from 'react';
import CustomInput from 'components/common/CustomInput/CustomInput';
import styles from '../VolunteerHoursTargetSettings.module.css';

const FlatRateConfig = ({ hoursPerMember, onChange }) => {
  const handleChange = (e) => {
    const value = e.target.value === '' ? '' : parseFloat(e.target.value) || 0;
    onChange(value);
  };

  return (
    <div className={styles.configSection}>
      <p className={styles.configDescription}>
        Set a fixed volunteer requirement for all members, regardless of how many athletes they have.
      </p>

      <div className={styles.flatRateRow}>
        <CustomInput
          label="Hours Per Member"
          type="number"
          min="0"
          step="0.5"
          value={hoursPerMember ?? ''}
          onChange={handleChange}
          placeholder="20.0"
        />
      </div>

      <div className={styles.exampleBox}>
        <strong>Example:</strong> Every member contributes {hoursPerMember || 0} hours, 
        regardless of how many athletes they have.
      </div>
    </div>
  );
};

export default FlatRateConfig;
